import { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { api, apiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { homeFor } from "@/lib/roles";
import { Shell } from "@/pages/Auth";
import { TwoFactor } from "@/pages/auth/TwoFactor";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";

/** Landing page after Google. Exchanges the one-time session id on the backend, then continues (2FA if needed). */
export default function AuthCallback() {
  const location = useLocation();
  const nav = useNavigate();
  const { setSession } = useAuth();
  const processed = useRef(false);
  const [mfa, setMfa] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const m = /session_id=([^&]+)/.exec(location.hash || "");
    if (!m) { setError("No sign-in session was found. Please try again."); return; }
    window.history.replaceState(null, "", location.pathname);
    api.post("/auth/google/session", { session_id: decodeURIComponent(m[1]) })
      .then(({ data }) => {
        if (data.mfa_required) setMfa(data);
        else { setSession(data); nav(homeFor(data.role), { replace: true }); }
      })
      .catch((e) => setError(apiError(e.response?.data?.detail)));
  }, [location, nav, setSession]);

  const finish = (u) => { setSession(u); nav(homeFor(u.role), { replace: true }); };

  if (mfa)
    return <Shell title="Check your email" sub="One more step keeps your family's information safe."><TwoFactor mfa={mfa} onSuccess={finish} /></Shell>;
  if (error)
    return (
      <Shell title="We couldn't sign you in" sub="">
        <p className="mt-6 text-sm font-semibold text-[#EF4444] bg-red-50 rounded-2xl p-4" data-testid="google-error">{error}</p>
        <Link to="/login"><Button className="mt-6 w-full h-12 rounded-full bg-[#3B82F6] hover:bg-[#2563EB] font-bold" data-testid="google-error-back">Back to sign in</Button></Link>
      </Shell>
    );
  return <div className="min-h-screen grid place-items-center text-muted-foreground" data-testid="google-processing">Finishing sign-in…</div>;
}
